(ns frontend.view.settings2.surveys.timeseries.tab-forecast
  (:require [common.localization :as loc]
            [common.schema.entities.survey.timeseries :as timeseries]
            [frontend.view.settings2.surveys.events :as config-event]

            [re-frame.core :as rf]
            [ui.components.radio-group.view :as radio-group]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn view
  [{:keys [block-idx]} {:keys [forecast forecast-in-use? snapshot-forecast?]}]
  [:div
   {:class "flex flex-col gap-4"}
   [labelled-input/view
    {:label       (loc/tr :request-forecast-data)
     :data-type   :data.type/boolean
     :editor-type :editor.type/toggle
     :horizontal? true
     :reverse?    true
     :value       (boolean forecast-in-use?)
     :on-change   (fn [v]
                    (rf/dispatch [::config-event/set-table-forecast-in-use? block-idx v]))}]
   [labelled-input/view
    {:label       (loc/tr :snapshot-data?)
     :data-type   :data.type/boolean
     :editor-type :editor.type/toggle
     :horizontal? true
     :reverse?    true
     :value       (boolean snapshot-forecast?)
     :disabled?   (not forecast-in-use?)
     :on-change   (fn [v]
                    (rf/dispatch [::config-event/set-table-forecast-snapshot? block-idx v]))}]
   (when forecast-in-use?
     [:div
      {:class "flex flex-row gap-4"}
      [:div
       {:class "flex-1 pr-4 border-r-[3px] border-solid border-complement-light-border"}
       [:h3
        {:class "p-2 mb-2 text-complement-regular-text bg-complement-regular"}
        (loc/tr :from-reference-date-until-end-of-year)]
       [radio-group/radio-group-v2
        {:checked   forecast
         :name      (str ::forecast)
         :on-change (fn [value]
                      (rf/dispatch [::config-event/set-table-forecast block-idx value]))}
        (->> timeseries/forecast-options-ref-date-end-of-year
             (mapv (fn [k]
                     {:value   k
                      :content (loc/tr k)})))]]
      [:div
       {:class "flex-1 pr-4 border-r-[3px] border-solid border-complement-light-border"}
       [:h3
        {:class "p-2 mb-2 text-complement-regular-text bg-complement-regular"}
        (loc/tr :from-reference-date-rolling)]
       [radio-group/radio-group-v2
        {:checked   forecast
         :name      (str ::forecast)
         :on-change (fn [value]
                      (rf/dispatch [::config-event/set-table-forecast block-idx value]))}
        (->> timeseries/forecast-options-rolling
             (mapv (fn [k]
                     {:value   k
                      :content (loc/tr k)})))]]
      [:div
       {:class "flex-1"}
       [:h3
        {:class "p-2 mb-2 text-complement-regular-text bg-complement-regular"}
        (loc/tr :full-calendar-year-including-reference-date)]
       [radio-group/radio-group-v2
        {:checked   forecast
         :name      (str ::forecast)
         :on-change (fn [value]
                      (rf/dispatch [::config-event/set-table-forecast block-idx value]))}
        (->> timeseries/forecast-options-full-calendar-year
             (mapv (fn [k]
                     {:value   k
                      :content (loc/tr k)})))]]])])
